import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import classNames from "classnames";
import {getLangCode, stringBundle} from '../../stringBundle';
import * as validation from '../../helpers/validation';
import utils from '../../helpers/utils';

/*eslint-disable no-unused-vars*/
/*eslint-disable no-class-assign*/
/*eslint-disable prefer-template*/

const renderField = ({input, label, type, meta: {touched, error, warning}}) => (
  <div className="w-full mt-4">
    <div className="input-field relative">
      <input {...input} className={classNames({
        'input-style validate w-full border relative text-base cursor-pointer h-13 px-4':true,
        'border-grey-lighter hover:border-blue' : !(error && touched),
        'border-red': !!(error && touched),
        'pt-5 pb-3' : (!!input.value && input.value !== ''),
      })} type={type} placeholder={label}/>
      <label htmlFor="label" className={classNames({
        'text-grey-light transition absolute pin-t pin-l text-xs pt-1 pl-4':true,
        'hidden': input.value === ""
      })}> {label} </label>
      {touched && ((error && <span className="text-xs text-red">{error}</span>) || (warning && <span className="text-xs text-red">{warning}</span>))}
    </div>
  </div>
)

class EditSMSModalForm extends Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.localizedStringBundle = stringBundle(getLangCode());
    const {error, handleSubmit, valid, invalid, pristine, submitting, onSubmit} = props;
  }

  handleClick(e) {
    e.preventDefault();
    utils.trackEventForManageAccount('Contact_Text', this.localizedStringBundle.MANAGE_ACCOUNT_CANCEL, true);
    this.props.dispatch({type: 'HIDE_MODAL'});
  }

  render() {
    const disabled = this.props.pristine || this.props.submitting || this.props.invalid;
    const btnClasses = classNames({
      'w-32 md:w-35 h-10 text-sm': true,
      'text-grey bg-grey-lighter disabled': !!disabled,
      'text-black bg-yellow hover:bg-yellow-dark': !disabled,
      });
    return (
      <form method="post" onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
        <div className="flex">
          <div className="w-full pt-8">
            <Field name="phoneNumber" type="tel" label="Phone Number" component={renderField}
                   validate={[validation.requiredText("Phone Number"), validation.equalLengthDigits(10), validation.noZeroOrOneStart, validation.phone]}/>
          </div>
        </div>
        <div className="pt-4">
          <p className="text-xs">{this.localizedStringBundle.MANAGE_ACCOUNT_SMS_RATES_APPLY}</p>
          <p className="text-xs py-4">{this.localizedStringBundle.MANAGE_ACCOUNT_SMS_SUBSCRIBE_TEXT1}
            <a target="_blank" rel="noopener noreferrer" className="text-blue-bright no-underline"
               href="https://www.lifelock.com/legal1/terms">{this.localizedStringBundle.ONBOARDING_TEXT_TERMS}</a></p>
        </div>
        <div className="py-3 submit-btn-group">
          <button id="btn-newsms" className={btnClasses} type="submit" disabled={disabled}>
            Save
          </button>
          <button className="border-1 border-yellow text-black h-10 w-32 md:w-35 ml-4 hover:bg-yellow-dark capitalize" tabIndex={0} onClick={this.handleClick}>{this.localizedStringBundle.CANCEL}</button>
        </div>
      </form>
    )
  }

}

EditSMSModalForm.propTypes = {
  error: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func,
};

renderField.propTypes = {
  input: PropTypes.object,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object,
  label: PropTypes.string,
};

EditSMSModalForm = reduxForm({
  form: 'editnewsms'
})(EditSMSModalForm)

export default EditSMSModalForm;

/*eslint-enable no-unused-vars*/
/*eslint-enable no-class-assign*/
/*eslint-enable prefer-template*/



// WEBPACK FOOTER //
// ./src/containers/monitoring/EditSMSModalForm.js